(function () {
  async function handleFdoCartToggle(toggle) {
    toggle.disabled = true;
    const giftVariantId = toggle.dataset.giftVariantId;
    const mainVariantId = toggle.dataset.mainVariantId;
    const isChecked = toggle.checked;
    const sections = 'cart-drawer,cart-icon-bubble';

    try {
      let parsedState;

      if (isChecked) {
        const giftLabel = toggle.getAttribute('aria-label') || '';
        const res = await fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(giftVariantId),
              quantity: 1,
              properties: {
                '_gwp-product': 'true',
                '_gwp-product-for': mainVariantId,
                '_fathers-day-item': 'gift',
                ...(giftLabel ? { '_fdo-gift-label': giftLabel } : {}),
              },
            }],
            sections,
            sections_url: window.location.pathname,
          }),
        });
        parsedState = await res.json();
        if (!res.ok || parsedState.status) throw new Error(parsedState.description || 'Failed to add gift');
      } else {
        const itemKey = toggle.dataset.giftItemKey;
        if (!itemKey) { toggle.disabled = false; return; }
        const res = await fetch(`${routes.cart_change_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: itemKey, quantity: 0, sections, sections_url: window.location.pathname }),
        });
        parsedState = await res.json();
      }

      await fetch(routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { card: isChecked ? 'true' : '' } }),
      }).catch(() => {});

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState, 'add-to-cart-form');
      }
      if (window.CartOptimist) CartOptimist.reconcile(parsedState);
      if (typeof updateCartAndProductJSON === 'function') updateCartAndProductJSON();
    } catch (err) {
      console.error('[FDO] Cart toggle error:', err);
      toggle.checked = !isChecked;
      toggle.disabled = false;
    }
  }

  document.addEventListener('change', function (e) {
    const toggle = e.target.closest('.js-fdo-cart-toggle');
    if (toggle) handleFdoCartToggle(toggle);
  });
})();
